import { gql } from '@apollo/client'

export type { CreateCompany, CreateCompanyVariables } from './types/index.graphql'

export const CREATE_COMPANY = gql`
  mutation CreateCompany($companyDTO: CreateCompanyInput!, $founderId: Int!) {
    createCompany(createCompanyDTO: $companyDTO, founderId: $founderId) {
      company {
        id
        name
        logo
        phoneNumber
        country {
          id
          lng
          code
          isoCode
        }
      }
    }
  }
`
